import { Component, ElementRef, inject, Input, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  selector: 'mailgun-html',
  template: ``,
  standalone: true,
  hostDirectives: [SsrMarkToUnwrapDirective],
})
export class EmailMailgunHtmlComponent {
  public sanitizer = inject(DomSanitizer);
  public elRef = inject(ElementRef);

  @Input() public html: WrappedValue<string | number>;

  public ngOnChanges() {
    this.update();
  }

  private update() {
    this.elRef.nativeElement.innerHTML = this.getSafeValue();
  }

  private getSafeValue() {
    return this.sanitizer.sanitize(SecurityContext.NONE, this.html.toJSON());
  }
}
